import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/operation/importer/operationImporterActions'

export default importerReducers(actions)
